import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const projects = [{
  id: 1,
  title: 'Drainage Installation',
  image: 'https://cdn.magicpatterns.com/uploads/vApfgLgy7mcJfnsowbGCEJ/heylloyd-image-1773555341321.png'
}, {
  id: 2,
  title: 'Walkway & Mulch Design',
  image: 'https://cdn.magicpatterns.com/uploads/f1T6TZZy1E173C9yis2xj9/heylloyd-image-1773555335166.png'
}, {
  id: 3,
  title: 'Sprinkler System Installation',
  image: 'https://cdn.magicpatterns.com/uploads/h8wB4LUJGDuXvQwVUqJ2S2/heylloyd-image-1774018775746.png'
}, {
  id: 4,
  title: 'Flower Bed & Landscaping',
  image: 'https://cdn.magicpatterns.com/uploads/taK8NNGfmwTmKTfJz6n3Fq/heylloyd-image-1774018732399.png'
}, {
  id: 5,
  title: 'Full Lawn Service',
  image: 'https://cdn.magicpatterns.com/uploads/njZQ9ZMT6jE6wTxMQQTvfj/heylloyd-image-1774019804068.png'
}, {
  id: 6,
  title: 'Stone Walkway Design',
  image: 'https://cdn.magicpatterns.com/uploads/jDB8ivxDjh3sE5daagpxJ7/heylloyd-image-1774020338433.png'
}];
export function GallerySection() {
  return <section id="gallery" className="py-20 md:py-32 bg-[#f9f7f2] relative overflow-hidden" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-165">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block py-1 px-3 rounded-full bg-[#2D5A27]/10 border border-[#2D5A27]/20 text-[#2D5A27] text-sm font-semibold tracking-wider uppercase mb-6" data-id="element-166">
            Our Work
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-bold text-[#1B2E1B] mb-6 tracking-tight" data-id="element-167">
            See the difference we make
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-600 leading-relaxed" data-id="element-168">
            From overgrown yards to pristine landscapes. Browse our recent
            projects and imagine what we could do for your property.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-169">
          {projects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative aspect-square overflow-hidden rounded-2xl bg-gray-200 shadow-sm" data-id="element-170">
              <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-171" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6" data-id="element-172">
                <h3 className="text-white font-semibold text-lg translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-173">
                  {project.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-174">
          <p className="text-[#1B2E1B] font-medium mb-6 text-lg" data-id="element-175">
            Your lawn could be next. Let's make it happen.
          </p>
          <a href="tel:+1234567890" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-[#1B2E1B] bg-[#C5A55A] rounded-full hover:bg-[#d4b46a] transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-176">
            Get a Free Quote
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-177" />
          </a>
        </motion.div>
      </div>
    </section>;
}